import { takeSchummarPersisted } from '@/lib/takeSchummarPersisted';
import { persist, type Store } from 'cross-state';

/**
 * Persists a settings store in localStorage (synced across tabs) and takes over what schummar-state saved in the localforage
 * instance of the same name. Resolves once both are loaded.
 */
export async function persistSettings<T extends object>(store: Store<T>, id: string, paths?: readonly (keyof T & string)[]) {
    await persist(store, { id, storage: localStorage, paths: paths as never }).initialized;

    try {
        const legacy = await takeSchummarPersisted(id);
        if (!legacy) return;

        const taken = paths ? Object.fromEntries(Object.entries(legacy).filter(([key]) => paths.includes(key as never))) : legacy;
        store.set({ ...store.get(), ...taken } as T);
    } catch (e) {
        console.error(`Failed to take over the old ${id} settings`, e);
    }
}
